import { default as Select } from './version-select';

export const ProjectVersion = {
  Select,
};
